import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

/**
 * Inline editable dropdown for enum-like fields (e.g. dzi_category).
 * Shows a compact "chip" by default; clicking transforms it into a Select.
 * Auto-saves on change and auto-collapses.
 */
export default function InlineEditSelect({
    value,
    onSave,
    options = [], // [{ value, label }]
    testId,
    chipClassName = "",
}) {
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);

    const current = options.find((o) => o.value === value);
    const label = current?.label || value || "-";

    const commit = async (next) => {
        if (next === value) { setEditing(false); return; }
        setSaving(true);
        try {
            await onSave(next);
            setEditing(false);
        } catch (e) {
            toast.error(e?.response?.data?.detail || "更新失败");
        } finally {
            setSaving(false);
        }
    };

    if (!editing) {
        return (
            <button
                type="button"
                data-testid={testId}
                onClick={(e) => { e.stopPropagation(); setEditing(true); }}
                className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs hover:bg-gold-100 focus:bg-gold-100 focus:outline-none focus:ring-1 focus:ring-gold-400 cursor-pointer ${chipClassName || "border-gold-200 bg-gold-50/70 text-gold-700"}`}
                title="点击修改天珠分类"
            >
                {label}
            </button>
        );
    }

    return (
        <div onClick={(e) => e.stopPropagation()} className="inline-block">
            <Select
                open
                value={value || ""}
                onValueChange={commit}
                onOpenChange={(o) => { if (!o) setEditing(false); }}
            >
                <SelectTrigger data-testid={`${testId}-trigger`} className="h-7 w-32 text-xs">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {options.map((o) => (
                        <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {saving && <span className="text-[10px] text-gold-500 ml-1">…</span>}
        </div>
    );
}
